import React from 'react';
import './RoleBadge.css';

const RoleBadge = ({ role }) => {
    const getRoleConfig = () => {
        switch (role) {
            case 'admin':
                return {
                    label: 'ADMIN',
                    icon: 'fa-crown',
                    className: 'role-badge-admin'
                };
            case 'editor':
                return {
                    label: 'EDITOR',
                    icon: 'fa-pen',
                    className: 'role-badge-editor'
                };
            case 'viewer':
                return {
                    label: 'VIEWER',
                    icon: 'fa-eye',
                    className: 'role-badge-viewer'
                };
            default:
                return {
                    label: 'USER',
                    icon: 'fa-user',
                    className: 'role-badge-default'
                };
        }
    };

    const config = getRoleConfig();

    return (
        <span className={`role-badge ${config.className}`}>
            <i className={`fas ${config.icon}`}></i>
            {config.label}
        </span>
    );
};

export default RoleBadge;
